var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 15479"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6437"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.615 3.684a1.39 1.39 0 0 1 .981.984c.36.93.707 1.864 1.055 2.8a2.4 2.4 0 0 1 .107.442.91.91 0 0 1-.511 1.025q-.433.23-.876.441a.76.76 0 0 0-.452.665 2.03 2.03 0 0 0 .215 1.143 12.5 12.5 0 0 0 4.55 4.923 8 8 0 0 0 1.267.629 1.4 1.4 0 0 0 .884.027.69.69 0 0 0 .474-.376c.134-.273.275-.543.41-.815a.97.97 0 0 1 1.263-.583c.325.086.64.214.957.332q.9.331 1.788.673.229.087.451.192a1.36 1.36 0 0 1 .853.916v.372c-.081.3-.14.6-.248.886a3.93 3.93 0 0 1-2.672 2.515c-.262.077-.538.106-.807.157h-.644c-.261-.041-.524-.074-.782-.126a10.2 10.2 0 0 1-3.544-1.586 23.6 23.6 0 0 1-3.6-2.99 23.6 23.6 0 0 1-3.638-4.421 9.6 9.6 0 0 1-1.253-2.925c-.068-.307-.106-.62-.159-.93v-.643a1 1 0 0 0 .032-.147A3.89 3.89 0 0 1 6.242 3.97a8 8 0 0 1 1-.286Z",
  "data-name": "Path 16557"
}))));
export { SvgCallIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/call_icon.cc34c26d2aa5b28c610b014a9ffeda52.svg";